@if (module()) {
  <div>
    <app-page-title label="4D Training - {{ module().title }}" [canGoBack]="true" (click)="goBack()"></app-page-title>
    @if (module()) {
      <div class="video-container">
        @if (module().video) {
          <div class="">
            <video #video1 autoplay (timeupdate)="videoProgress($event)" #video controls id="video" autobuffer style="display: block; margin: 0 auto">
              <source src="https://s3-eu-west-1.amazonaws.com/4d-training/videos/{{ module().video }}" />
            </video>
          </div>
        }
        @if (module().document) {
          <div>
            <a class="btn btn-primary" href="https://train.4dml.com/assets/4DGatewayOnboardingforEngineers.pdf"> <i class="fa fa-file-pdf-o"></i> View Onboarding Guide</a>
          </div>
        }
      </div>
    }
    <!-- handle pause while transitioning to another module -->
    @if (transitionToModuleId && !module()) {
      <div class="col-xs-12">
        <p>Next module loading, please wait...</p>
      </div>
    }
  </div>
}
